export const baseApiUrl = process.env.REACT_APP_BASE_API_URL;

export const USER_TYPES = {
  SUPER_ADMIN: 'Super Admin',
  ADMIN: 'Organisation',
  USER:'Outlet Manager',
}

